import { TooltipDirective } from '../../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../../componentes/botones';
import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ISim } from 'modelos';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SimsService } from '../../../../../auxiliares/servicios/http/sims.service';

/**
 * Buscador de SIMs disponibles (sin asignación vigente) para los formularios
 * de tracker y alarma. Emite la SIM elegida; el formulario la carga en su
 * grupo con `SimsService.aplicarSeleccion`. "Nueva SIM" emite `null`.
 */
@Component({
  selector: 'app-selector-sim-disponible',
  standalone: true,
  imports: [
    TooltipDirective,
    ReactiveFormsModule,
    MatAutocompleteModule,
    BOTONES,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './selector-sim-disponible.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SelectorSimDisponibleComponent implements OnInit {
  private simsService = inject(SimsService);
  private destroyRef = inject(DestroyRef);

  /** Hay una SIM elegida o cargada: muestra el botón "Nueva SIM". */
  @Input() conSim = false;
  @Output() seleccion = new EventEmitter<ISim | null>();

  public busqueda = new FormControl<string>('', { nonNullable: true });
  public opciones: ISim[] = [];
  public buscando = false;
  public buscado = false;

  ngOnInit(): void {
    this.busqueda.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((texto) => this.buscar(texto));
  }

  /** Al enfocar sin texto, lista las primeras disponibles. */
  public alEnfocar(): void {
    if (!this.buscado) this.buscar(this.busqueda.value);
  }

  private async buscar(texto: string): Promise<void> {
    if (typeof texto !== 'string') return;
    this.buscando = true;
    try {
      this.opciones = await this.simsService.disponibles(texto.trim());
    } catch {
      this.opciones = [];
    } finally {
      this.buscando = false;
      this.buscado = true;
    }
  }

  public elegir(sim: ISim): void {
    this.seleccion.emit(sim);
    this.busqueda.setValue('', { emitEvent: false });
    this.buscado = false;
  }

  public nueva(): void {
    this.seleccion.emit(null);
  }

  public etiqueta(sim: ISim): string {
    return [sim.iccid || 'Sin ICCID', sim.numero, sim.operador]
      .filter(Boolean)
      .join(' · ');
  }
}
